import { AdjustTermKey, PairedSalesAnalysisFeature } from '@aloft/toolkit-shared';
import { IconName } from '@aloft/toolkit-sui';

import { isPairedSalesCustomAnalysisFeature } from '../../adjustPairedSalesStandalone/utils/isPairedSalesCustomAnalysisFeature.ts';

const termIconDictionary: { [key in AdjustTermKey]?: IconName } = {
  aboveGradeBedroomCount: 'bedrooms',
  aboveGradeFullBathCount: 'baths',
  aboveGradeHalfBathCount: 'baths',
  carportParkingSpacesCount: 'parking',
  cooling: 'cooling',
  design: 'attachment',
  designAttachmentType: 'attachment',
  garageParkingSpacesCount: 'parking',
  greenEnergyEfficient: 'energy-efficiency',
  grossLivingArea: 'gla',
  heating: 'heating',
  location: 'location',
  pool: 'pool',
  porchPatioDeck: 'patio-porch',
  site: 'lot-size',
  totalBasementArea: 'basement-sf',
  view: 'view',
};

export function getIcon(feature: PairedSalesAnalysisFeature): IconName {
  if (isPairedSalesCustomAnalysisFeature(feature)) return 'other';

  const iconName = termIconDictionary[feature];

  return iconName || 'other';
}
